export default {"src":"/_next/static/media/hud1.b6120f88.svg","height":95,"width":188,"blurWidth":0,"blurHeight":0};